export function anchor(){
    const header = document.querySelector('.header') as HTMLElement | null;
    const anchors = document.querySelectorAll('.anchor') as NodeListOf<HTMLAnchorElement>;
    const body = document.body;

    const getHeaderHeight = (): number => header ? header.offsetHeight : 0;

    // === Установка класса active ===
    const setActiveAnchor = (active: HTMLAnchorElement): void => {
        anchors.forEach(a => a.classList.remove('active'));
        active.classList.add('active');
    };

    // === Плавный скролл при клике ===
    anchors.forEach(anchor => {
        anchor.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();

            const href = anchor.getAttribute('href');
            if (!href || href === '#') return;

            const target = document.querySelector(href) as HTMLElement | null;
            if (!target) return;

            const offset = target.getBoundingClientRect().top + window.scrollY - getHeaderHeight() - 10;

            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });

            // Убираем активность меню, если оно открыто
            if (body.classList.contains('menu-active')) {
                body.classList.remove('menu-active');
            }

            // Обновляем активную ссылку
            setActiveAnchor(anchor);
        });
    });

    // === Активный пункт при скролле ===
    const handleScroll = (): void => {
        const scrollPos = window.scrollY + getHeaderHeight() + 20;

        anchors.forEach(anchor => {
            const href = anchor.getAttribute('href');
            if (!href || href === '#') return;

            const section = document.querySelector(href) as HTMLElement | null;
            if (!section) return;

            const top = section.offsetTop;
            const bottom = top + section.offsetHeight;

            if (scrollPos >= top && scrollPos < bottom) {
                setActiveAnchor(anchor);
            }
        });
    };

    window.addEventListener('scroll', handleScroll);
}